
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91slug_93cX44IjaFo6Bzv12TQq3eptEkkrPcS1Z6dl5jqWKjzrsMeta } from "/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/pages/articles/[slug].vue?macro=true";
import { default as _91slug_93Prpeb6lNSXXN95cl2Exo8UjM5c4oIeFuo95vb1uXgTIMeta } from "/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/pages/portfolio/[slug].vue?macro=true";
import { default as indexJ6zOC8QnMJTScSwMvHpBS9i4hikIYu9zfWwKQzK8yGgMeta } from "/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/pages/articles/index.vue?macro=true";
import { default as careerbgzmOkXrf_MDgcVG6pXqqbel7v018VUBxstUByhop74Meta } from "/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/pages/career.vue?macro=true";
import { default as contactCZrOGn8VoIB_a8lkitKFL6N1oX_R569qTbLJd9mEPYUMeta } from "/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/pages/contact.vue?macro=true";
import { default as datenschutzaX3na1zs8NxjqgNsQ_1Wd2_9nCuQFX_v7GPIMq3l968Meta } from "/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/pages/datenschutz.vue?macro=true";
import { default as expertiseFZHL2foby8QG52XX0dWClSe3bYhPR6DPgBe7T7f_XMYMeta } from "/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/pages/expertise.vue?macro=true";
import { default as impressumbfbT2_PX7yzmWWRy1q2X2ftMbhcGIzOyMDCIvozw2e4Meta } from "/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/pages/impressum.vue?macro=true";
import { default as index_jKaAjDiwF89fg14cH9HIZjussvYRx6Y9ZvYZQHZSHMMeta } from "/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/pages/portfolio/index.vue?macro=true";
import { default as indexwLvm4gw52T98jHe_P8pzZ_U5XOLbjc5anJp_5pYV_mcMeta } from "/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/pages/index.vue?macro=true";
export default [
  {
    name: "articles-slug",
    path: "/articles/:slug()",
    component: () => import("/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/pages/articles/[slug].vue")
  },
  {
    name: "portfolio-slug",
    path: "/portfolio/:slug()",
    component: () => import("/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/pages/portfolio/[slug].vue")
  },
  {
    name: "articles",
    path: "/articles",
    component: () => import("/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/pages/articles/index.vue")
  },
  {
    name: "career",
    path: "/career",
    component: () => import("/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/pages/career.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/pages/contact.vue")
  },
  {
    name: "datenschutz",
    path: "/datenschutz",
    component: () => import("/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/pages/datenschutz.vue")
  },
  {
    name: "expertise",
    path: "/expertise",
    component: () => import("/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/pages/expertise.vue")
  },
  {
    name: "impressum",
    path: "/impressum",
    component: () => import("/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/pages/impressum.vue")
  },
  {
    name: "portfolio",
    path: "/portfolio",
    component: () => import("/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/pages/portfolio/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/pages/index.vue")
  }
]